import React from "react";
import { FaIcon } from "./Fa.Icon";

export function GroupCallIcon() {
  return <FaIcon name={"users-viewfinder"} type={"s"} />;
}
